import React from 'react';
import Icon from '../../../components/AppIcon';
import CreateAgentButton from './CreateAgentButton';

const EmptyState = ({ hasSearchTerm, searchTerm, hasFilters }) => {
  if (hasSearchTerm || hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Keine Agenten gefunden
        </h3>
        <p className="text-muted-foreground text-center max-w-md mb-4">
          {hasSearchTerm 
            ? `Keine Agenten entsprechen der Suche "${searchTerm}". Versuchen Sie andere Suchbegriffe.`
            : 'Keine Agenten entsprechen den ausgewählten Filtern. Passen Sie Ihre Filter an.'
          }
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
        <Icon name="Bot" size={40} className="text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        Willkommen bei Vibecoding
      </h3>
      <p className="text-muted-foreground text-center max-w-md mb-6">
        Sie haben noch keine AI-Agenten erstellt. Beginnen Sie mit der Erstellung Ihres ersten Chatbots, um Ihre Kunden zu unterstützen.
      </p>
      <CreateAgentButton />
    </div>
  );
};

export default EmptyState;